<div class="status-indicator" data-e2e="status-indicator">
  <div class="dot" [ngClass]="statusColorMapping[status]?.color"></div>
  {{ statusColorMapping[status]?.name }}
</div>
